import { createBrowserRouter, Navigate } from "react-router-dom";
import routes from "./config/routes";

import MainLayout from "./components/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import DashboardPage from "./pages/DashboardPage";
import MatchDetailPage from "./pages/MatchDetailPage";
import FancySessionDetailPage from "./pages/FancySessionDetailPage";
import CompletedFancyBetsPage from "./pages/CompletedFancyBetsPage";   // ← NEW
import CompletedMatchesPage from "./pages/CompletedMatchesPage";
import LoginPage from "./pages/LoginPage";
import MiniAdminListPage from "./pages/MiniAdminListPage";
import CreateUserPage from "./pages/CreateUserPage";
import UpdateLimitPage from "./pages/UpdateLimitPage";
import UserListPage from "./pages/UserListPage";
import EditUserPage from "./pages/EditUserPage";
import StatementPage from "./pages/StatementPage";
import AccountOperationsPage from "./pages/AccountOperationsPage";
import LoginReportPage from "./pages/LoginReportPage";
import ProfitLossPage from "./pages/ProfitLossPage";
import MyLedgerPage from "./pages/MyLedgerPage";
import UserLedgerPage, { LEDGER_USER_TYPES } from "./pages/UserLedgerPage";
import TotalProfitPage from "./pages/TotalProfitPage";
import MiniLedgerPage from "./pages/MiniLedgerPage";
import UserDownlineLedgerPage from "./pages/UserDownlineLedgerPage";
import MasterTransactionsPage from "./pages/MasterTransactionsPage";
import CashTransactionPage, {
  TRANSACTION_USER_TYPES,
} from "./pages/CashTransactionPage";
import ReportsLoginReportPage from "./pages/ReportsLoginReportPage";
import CompanyReportDatePage from "./pages/CompanyReportDatePage";
import SecureCodeReportPage from "./pages/SecureCodeReportPage";
import CommissionLenDenPage from "./pages/CommissionLenDenPage";
import CommissionDetailsPage from "./pages/CommissionDetailsPage";
import ActiveGamesPage from "./pages/ActiveGamesPage";
import CompletedGamesPage from "./pages/CompletedGamesPage";
import CasinoMatchLedgerPage from "./pages/CasinoMatchLedgerPage";
import UserSearchPage from "./pages/UserSearchPage";
import StatementReportPage from "./pages/StatementReportPage";
import AccountOperationsReportPage from "./pages/AccountOperationsReportPage";
import CasinoProfitLossPage from "./pages/CasinoProfitLossPage";
import UrBetSettingPage from "./pages/UrBetSettingPage";
import MatchSessionPlusMinusSelectionPage from "./pages/MatchSessionPlusMinusSelectionPage";
import MatchSessionPlusMinusLedgerPage from "./pages/MatchSessionPlusMinusLedgerPage";
import CompanyReportPage from "./pages/CompanyReportPage";
import CompanyReportDownlinePage from "./pages/CompanyReportDownlinePage";
import MatchBetsPage from "./pages/MatchBetsPage";
import FancyBetsPage from "./pages/FancyBetsPage";
import FancyProfitLossPage from "./pages/FancyProfitLossPage";
import RejectedBetsPage from "./pages/RejectedBetsPage";
import DeadClientPage from "./pages/DeadClientPage";
import MatkaBetStatusPage from "./pages/MatkaBetStatusPage";
import SuperAdminMatkaBetLockPage from "./pages/SuperAdminMatkaBetLockPage";
import CompletedCasino from "./pages/CompletedCasino";
import CompletedCasinoPlusMinus from "./pages/CompletedCasinoPlusMinus";
import AgentPlusMinusPage from "./pages/AgentPlusMinusPage";
import CasinoDetailsPage from "./pages/CasinoDetailsPage";
import CasinoDisplayGamesPage from "./pages/CasinoDisplayGamesPage";
import CasinoAllBetsPage from "./pages/CasinoAllBetsPage";
import CasinoCompanyReportPage from "./pages/CasinoCompanyReportPage";
import { USER_TYPES } from "./store/actions/userManagement";
import CasinoViewRouter from "./pages/CasinoViewRouter";
import DownlinePage from "./pages/DownlinePage";
import DownlineByIdPage from "./pages/DownlineByIdPage";
import MatkaListPage from "./pages/MatkaListPage";
import MatkaDetailPage from "./pages/MatkaDetailPage";
import SetMatkaResultPage from "./pages/SetMatkaResultPage";
import SetMessagePage from "./pages/SetMessagePage";
import SiteThemePage from "./pages/SiteThemePage";
import SettingPage from './pages/SettingPage';
import SearchUserPage from './pages/SearchUserPage';
import AdminAccountStatementPage from './pages/AdminAccountStatementPage';
import ClientAccountOperationsPage from './pages/ClientAccountOperationsPage';
import DebitCreditEntryPage from "./pages/DebitCreditEntryPage";
import DeletedLendenPage from "./pages/DeletedLendenPage";
import InplayCasinoPage from "./pages/InplayCasinoPage";
import CompletedCasinoPage from "./pages/CompletedCasinoPage";
import CasinoGameDetailPage from "./pages/CasinoGameDetailPage";
import InplayMatkaPage from "./pages/InplayMatkaPage";
import CompletedMatkaPage from "./pages/CompletedMatkaPage";
import MatkaAllBetsPage from "./pages/MatkaAllBetsPage";
import MatkaBetPage from "./pages/MatkaBetPage";
import MatkaAgentReportPage from "./pages/MatkaAgentReportPage";
import TossBetsPage from "./pages/TossBetsPage";
import InplayLudoPage from "./pages/InplayLudoPage";
import LudoLivePage from "./pages/LudoLivePage";
import LudoRoundsPage from "./pages/LudoRoundsPage";
import CompletedLudoPage from "./pages/CompletedLudoPage";
import LudoDisplayGamesPage from "./pages/LudoDisplayGamesPage";
import LudoAllBetsPage from "./pages/LudoAllBetsPage";
import LudoCompanyReportPage from "./pages/LudoCompanyReportPage";
import AviatorLivePage from "./pages/AviatorLivePage";
import AviatorRoundsPage from "./pages/AviatorRoundsPage";
import AviatorRoundBetsPage from "./pages/AviatorRoundBetsPage";
import AviatorCompanyReportPage from "./pages/AviatorCompanyReportPage";
import RouletteLivePage from "./pages/RouletteLivePage";
import RouletteRoundsPage from "./pages/RouletteRoundsPage";
import RouletteRoundBetsPage from "./pages/RouletteRoundBetsPage";
import RouletteCompanyReportPage from "./pages/RouletteCompanyReportPage";
import FinancePage from "./pages/FinancePage";

const SuperAdminListPage = function () {
  return <UserListPage userType={USER_TYPES.SUPERADMIN} title="Super Admin Details" />;
};
const AdminListPage = function () {
  return <UserListPage userType={USER_TYPES.ADMIN} title="Admin Details" />;
};
const MasterListPage = function () {
  return <UserListPage userType={USER_TYPES.MASTER} title="Master Details" />;
};
const SuperListPage = function () {
  return <UserListPage userType={USER_TYPES.SUPER} title="Super Details" />;
};
const SuperMasterListPage = function () {
  return <UserListPage userType={USER_TYPES.SUPERMASTER} title="Super Master Details" />;
};
const AgentListPage = function () {
  return <UserListPage userType={USER_TYPES.AGENT} title="Agent Details" />;
};
const ClientListPage = function () {
  return <UserListPage userType={USER_TYPES.CLIENT} title="Client Details" />;
};

// const MiniAdminLedgerPage = function () {
//   return <UserLedgerPage userType={LEDGER_USER_TYPES.MINIADMIN} title="Mini Admin Ledger" />;
// };
// const SuperAgentLedgerPage = function () {
//   return <UserLedgerPage userType={LEDGER_USER_TYPES.SUPERMASTER} title="Super Agent Ledger" />;
// };
// const AdminLedgerPage = function () {
//   return <UserLedgerPage userType={LEDGER_USER_TYPES.ADMIN} title="Admin Ledger" />;
// };
// const SuperAdminLedgerPageWrapper = function () {
//   return <UserLedgerPage userType={LEDGER_USER_TYPES.SUPERADMIN} title="Super Admin Ledger" />;
// };

const ClientTransactionPage = function () {
  return <DebitCreditEntryPage userType={1} title="Client Transactions" />;
};
const AgentTransactionPage = function () {
  return <DebitCreditEntryPage userType={2} title="Agent Transactions" />;
};
const SuperAgentTransactionPage = function () {
  return <DebitCreditEntryPage userType={3} title="Super Agent Transactions" />;
};
const MasterTransactionPage = function () {
  return <DebitCreditEntryPage userType={4} title="Master Transactions" />;
};
const MiniAdminTransactionPage = function () {
  return <DebitCreditEntryPage userType={5} title="Mini Admin Transactions" />;
};
const SuperAdminTransactionPage = function () {
  return <DebitCreditEntryPage userType={7} title="Super Admin Transactions" />;
};

const router = createBrowserRouter([
  {
    path: routes.LOGIN,
    element: (
      // <PublicRoute>
        <LoginPage />
      // </PublicRoute>
    ),
  },
  {
    path: routes.DEFAULT,
    element: (
      // <ProtectedRoute>
        <MainLayout />
      // </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to={routes.DASHBOARD} replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "dashboard/match/:matchId", element: <MatchDetailPage /> },
      { path: "dashboard/match/:matchId/fancy/:fancyId", element: <FancySessionDetailPage /> },
      {
        path: "dashboard/match/:matchId/completed-fancy/:fancyId/:fancyName",
        element: <CompletedFancyBetsPage />,
      },
      { path: "admin-details/super-admin", element: <SuperAdminListPage /> },
      { path: "admin-details/admin", element: <AdminListPage /> },
      { path: "admin-details/mini-admin", element: <MiniAdminListPage /> },
      { path: "admin-details/master", element: <MasterListPage /> },
      { path: "admin-details/super", element: <SuperListPage /> },
      { path: "admin-details/super-master", element: <SuperMasterListPage /> },
      { path: "admin-details/agent", element: <AgentListPage /> },
      { path: "admin-details/client", element: <ClientListPage /> },
      { path: "admin-details/downline/:parentId/:parentUserType/:parentName", element: <DownlinePage /> },
      { path: "admin-details/downline-by-id/:adminId/:parentUserType/:parentName", element: <DownlineByIdPage /> },
      { path: "admin-details/create/:userType", element: <CreateUserPage /> },
      { path: "admin-details/update-limit/:userType", element: <UpdateLimitPage /> },
      { path: "admin-details/edit/:userId", element: <EditUserPage /> },
      { path: "admin-details/statement/:userId", element: <StatementPage /> },
      { path: "admin-details/account-operations/:userId", element: <AccountOperationsPage /> },
      { path: "admin-details/login-report/:userId", element: <LoginReportPage /> },
      { path: "sports-detail/cricket", element: <ActiveGamesPage /> },
      { path: "sports-detail/completed-matches", element: <CompletedMatchesPage /> },
      { path: "sports-betting/active-games", element: <ActiveGamesPage /> },
      { path: "sports-betting/finished-games", element: <CompletedGamesPage /> },
      { path: "sports-betting/set-matka-result", element: <SetMatkaResultPage /> },
      { path: "sports-betting/match-session-plus-minus/:matchId/:matchName", element: <MatchSessionPlusMinusSelectionPage /> },
      { path: "sports-betting/match-session-ledger/:matchId/:matchName", element: <MatchSessionPlusMinusLedgerPage /> },
      { path: "sports-betting/company-report/:matchId/:matchName", element: <CompanyReportPage /> },
      { path: "sports-betting/company-report/:eventId/:matchName/downline/:userId", element: <CompanyReportDownlinePage /> },
      { path: "sports-betting/match-bets/:matchId/:matchName", element: <MatchBetsPage /> },
      { path: "sports-betting/toss-bets/:matchId/:matchName", element: <TossBetsPage /> },
      { path: "sports-betting/fancy-bets/:matchId/:matchName", element: <FancyBetsPage /> },
      { path: "sports-betting/fancy-profit-loss/:matchId/:matchName", element: <FancyProfitLossPage /> },
      { path: "sports-betting/rejected-bets/:matchId/:matchName", element: <RejectedBetsPage /> },
      { path: "sports-betting/matka", element: <MatkaListPage /> },
      { path: "sports-betting/matka/:matchId", element: <MatkaDetailPage /> },
      { path: "matka/inplay", element: <InplayMatkaPage /> },
      { path: "matka/completed", element: <CompletedMatkaPage /> },
      { path: "matka/bets", element: <MatkaBetPage /> },
      { path: "matka/all-bets/:eventId/:name", element: <MatkaAllBetsPage /> },
      { path: "matka/agent-report/:eventId", element: <MatkaAgentReportPage /> },
      { path: "ludo/inplay", element: <InplayLudoPage /> },
      { path: "ludo/live/aviator", element: <AviatorLivePage /> },
      { path: "ludo/aviator-rounds/:date", element: <AviatorRoundsPage /> },
      { path: "ludo/aviator-round-bets/:roundId", element: <AviatorRoundBetsPage /> },
      { path: "ludo/aviator-company-report", element: <AviatorCompanyReportPage /> },
      { path: "roulette/live/:gameId", element: <RouletteLivePage /> },
      { path: "roulette/rounds/:date", element: <RouletteRoundsPage /> },
      { path: "roulette/round-bets/:roundId", element: <RouletteRoundBetsPage /> },
      { path: "roulette/company-report", element: <RouletteCompanyReportPage /> },
      { path: "ludo/live/:gameId", element: <LudoLivePage /> },
      { path: "ludo/completed", element: <CompletedLudoPage /> },
      { path: "ludo/rounds/:date", element: <LudoRoundsPage /> },
      { path: "ludo/display-games/:tableId/:gameName", element: <LudoDisplayGamesPage /> },
      { path: "ludo/all-bets/:date", element: <LudoRoundsPage /> },
      { path: "ludo/round-bets/:roundId", element: <LudoAllBetsPage /> },
      { path: "ludo/company-report", element: <LudoCompanyReportPage /> },
      { path: "finance", element: <FinancePage /> },
      { path: "casino/inplay-casino", element: <InplayCasinoPage /> },
      { path: "casino/game-detail/:gameId", element: <CasinoGameDetailPage /> },
      { path: "casino/casino-details", element: <CasinoDetailsPage /> },
      { path: "casino/international-casino", element: <CasinoMatchLedgerPage /> },
      { path: "sports-betting/agent-plus-minus/:matchId/:matchName", element: <AgentPlusMinusPage /> },
      { path: "casino/completed-casino", element: <CompletedCasino /> },
      { path: "/completed-casino-plus-minus", element: <CompletedCasinoPlusMinus /> },
      { path: "casino/display-games/:tableId/:gameName", element: <CasinoDisplayGamesPage /> },
      { path: "casino/all-bets/:roundId", element: <CasinoAllBetsPage /> },
      { path: "casino/company-report", element: <CasinoCompanyReportPage /> },
      { path: "casino/view/:tableId/:gameName", element: <CasinoViewRouter /> },
      { path: "ledger/total-profit", element: <TotalProfitPage /> },
      { path: "ledger/my-ledger", element: <MyLedgerPage /> },
      { path: "ledger/super-admin-ledger", element: <MiniLedgerPage userType="SuperAdmin" title="Super Admin Ledger" /> },
      { path: "ledger/mini-ledger", element: <MiniLedgerPage userType="MiniAdmin" title="Mini Ad Ledger" /> },
      { path: "ledger/master-ledger", element: <MiniLedgerPage userType="Master" title="Master Ledger" /> },
      { path: "ledger/super-ledger", element: <MiniLedgerPage userType="Super" title="Super Ledger" /> },
      { path: "ledger/agent-ledger", element: <MiniLedgerPage userType="Agent" title="Agent Ledger" /> },
      { path: "ledger/client-ledger", element: <MiniLedgerPage userType="Client" title="Client Ledger" /> },
      { path: "ledger/user-downline/:userId/:username/:userType", element: <UserDownlineLedgerPage /> },
      { path: "ledger/master-transactions/:userId", element: <MasterTransactionsPage /> },
      { path: "ledger/deleted-lenden/:userId", element: <DeletedLendenPage /> },
      { path: "ledger/comm-lenden", element: <CommissionLenDenPage /> },
      { path: "ledger/commission-details", element: <CommissionDetailsPage /> },
      { path: "cash-transaction/client", element: <ClientTransactionPage /> },
      { path: "cash-transaction/agent", element: <AgentTransactionPage /> },
      { path: "cash-transaction/super-agent", element: <SuperAgentTransactionPage /> },
      { path: "cash-transaction/master", element: <MasterTransactionPage /> },
      { path: "cash-transaction/mini-admin", element: <MiniAdminTransactionPage /> },
      { path: "cash-transaction/super-admin", element: <SuperAdminTransactionPage /> },
      { path: "reports/profit-loss", element: <ProfitLossPage /> },
      { path: "reports/login-report", element: <ReportsLoginReportPage /> },
      { path: "reports/company-report", element: <CompanyReportDatePage /> },
      { path: "reports/secure-code-report", element: <SecureCodeReportPage /> },
      { path: "settings/ur-bet-setting", element: <UrBetSettingPage /> },
      { path: "settings/set-message", element: <SetMessagePage /> },
      { path: "settings/site-theme", element: <SiteThemePage /> },
      { path: "settings/setting", element: <SettingPage /> },
      { path: "settings/search-user", element: <SearchUserPage /> },
      { path: "settings/account-statement", element: <AdminAccountStatementPage /> },
      { path: "settings/account-operations", element: <ClientAccountOperationsPage /> },
      { path: "settings/user-search", element: <UserSearchPage /> },
      { path: "settings/statement-report", element: <StatementReportPage /> },
      { path: "settings/account-operations/:userId", element: <AccountOperationsReportPage /> },
      { path: "settings/casino-profit-loss", element: <CasinoProfitLossPage /> },
      { path: "settings/dead-client/:userType", element: <DeadClientPage /> },
      { path: "settings/superadmin-matka", element: <SuperAdminMatkaBetLockPage /> },
      { path: "settings/matka", element: <MatkaBetStatusPage /> },
      { path: "settings/casino", element: <MatkaBetStatusPage /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to={routes.DEFAULT} replace />,
  },
]);

export default router;